import { GetInstitutionPersonnelNames, InstitutionPersonnelNamesResponse } from "@/api/dtos";
import { useGet } from "@ngt/opms";
import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

// BctApiClient.Models.Dtos.BctApi.Role.PrincipalInvestigator
export const PRINCIPAL_INVESTIGATOR_ROLE_ID = 13;

const getData = (
    response?: SWRResponse<InstitutionPersonnelNamesResponse, InstitutionPersonnelNamesResponse>
) => Object.values(response?.data?.personnelNames ?? {})[0];

const getError = (
    response?: SWRResponse<InstitutionPersonnelNamesResponse, InstitutionPersonnelNamesResponse>
) => (response?.error ?? response?.data)?.responseStatus;

export const usePrincipalInvestigator = (
    institutionCode?: string,
    configuration?: SWRConfiguration
) => {
    const request = useMemo(() => institutionCode
        ? () => new GetInstitutionPersonnelNames({
            institutionCode,
            roles: [PRINCIPAL_INVESTIGATOR_ROLE_ID]
        })
        : undefined,
    [institutionCode]);

    return useGet(request, { getData, getError }, configuration);
};

export default usePrincipalInvestigator;
